var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('comHeader',{attrs:{"activeIndex":'1'}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homemain"},[_c('img',{attrs:{"src":require("../images/index.png"),"alt":""}})])
}]

export { render, staticRenderFns }